import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Plus } from "lucide-react";
import Reveal from "../../Reveal";
import { useI18n } from "../../../i18n/LanguageContext";
import { SITE } from "../../../content/site";

export default function EventConsulting() {
  const { lang } = useI18n();
  const c = (SITE[lang].homeStory || SITE.en.homeStory).consulting;
  const [open, setOpen] = useState(-1);

  return (
    <section data-testid="home-consulting" className="bg-white px-6 py-28 md:px-12 md:py-40">
      <div className="mx-auto max-w-[1400px]">
        <div className="grid gap-14 lg:grid-cols-12">
          <div className="lg:col-span-4">
            <div className="lg:sticky lg:top-28">
              <Reveal><p className="overline text-[#0e7c6b]">{c.overline}</p></Reveal>
              <Reveal delay={0.1}>
                <h2 className="font-display mt-7 text-3xl font-light leading-[1.05] tracking-tightest text-[#050505] md:text-5xl">{c.title}</h2>
              </Reveal>
              <Reveal delay={0.2}>
                <p className="mt-6 max-w-md text-base font-light leading-relaxed text-[#4a4a4a] md:text-lg">{c.text}</p>
              </Reveal>
            </div>
          </div>

          <div className="lg:col-span-7 lg:col-start-6">
            {c.items.map((it, i) => {
              const isOpen = open === i;
              return (
                <Reveal key={i} delay={0.06 * i}>
                  <div data-testid={`consulting-item-${i}`} className="border-t border-black/10 last:border-b">
                    <button
                      data-testid={`consulting-toggle-${i}`}
                      onClick={() => setOpen(isOpen ? -1 : i)}
                      aria-expanded={isOpen}
                      className="flex w-full items-start justify-between gap-6 py-7 text-left"
                    >
                      <span className={`font-display text-xl font-light leading-snug tracking-tight transition-colors md:text-2xl ${isOpen ? "text-[#0e7c6b]" : "text-[#050505]"}`}>
                        {it.q}
                      </span>
                      <Plus size={20} className={`mt-1.5 shrink-0 text-[#9a9d98] transition-transform duration-300 ${isOpen ? "rotate-45 text-[#0e7c6b]" : ""}`} />
                    </button>
                    <AnimatePresence initial={false}>
                      {isOpen && (
                        <motion.div
                          initial={{ height: 0, opacity: 0 }} animate={{ height: "auto", opacity: 1 }} exit={{ height: 0, opacity: 0 }}
                          transition={{ duration: 0.5, ease: [0.16, 1, 0.3, 1] }}
                          className="overflow-hidden"
                        >
                          <p className="max-w-2xl pb-8 text-base font-light leading-relaxed text-[#4a4a4a] md:text-lg">{it.a}</p>
                        </motion.div>
                      )}
                    </AnimatePresence>
                  </div>
                </Reveal>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}
